import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

declare global {
  interface Window {
    BUILD_CONFIG?: {
      APP_VERSION: string;
      GIT_SHA: string;
      BUILD_TIME: string;
    };
    ENV_CONFIG?: {
      API_BASE: string;
      WS_BASE: string;
      ENVIRONMENT: string;
      DEPLOYED_AT: string;
      PREVIEW_CHANNEL?: string;
      SHOW_DB_BADGE?: boolean;
      DB_NAME?: string;
    };
    FRONTEND_CONFIG: {
      API_BASE: string;
      WS_BASE: string;
      BANNER_COLOR_START: string;
      BANNER_COLOR_END: string;
      ENVIRONMENT?: string;
      DEPLOYED_AT?: string;
    };
  }
}

// Add dark class to body for Tailwind CSS dark mode
document.body.classList.add('dark');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
